import type { FunctionComponent } from "react"

import { isBefore } from "date-fns"
import { useParams } from "next/navigation"

import { Text } from "@jobteaser/spark/components/Text"

import { JOBTEASER } from "@/modules/events/constants"
import { useEventDetailsData } from "@/modules/events/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

export const AttendanceRequired: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  if (!event) {
    return null
  }

  const { registrationDetails } = event

  if (registrationDetails.type !== JOBTEASER) {
    return null
  }

  const { startDate, registrationDeadline } = registrationDetails
  const currentDate = new Date()
  const registrationOpeningDate = new Date(startDate || "")
  const registrationLimitDate = new Date(registrationDeadline || "")
  const isRegistrationNotOpenYet = isBefore(currentDate, registrationOpeningDate)
  const isRegistrationDeadlineExceeded = isBefore(registrationLimitDate, currentDate)

  if (isRegistrationNotOpenYet || isRegistrationDeadlineExceeded) {
    return null
  }

  return (
    <Text data-testid="event-details-registration-details-attendance-required" variant="body2">
      {t("event_details.attendance.required.warning")}
    </Text>
  )
}
